
import useAxiosFetchApi from '../../hooks/useFetch';
import { useAuth, useProductsData } from '../../hooks/appHooks';
import EditProductModal from '../modals/EditModal';
import AddVendorProduct from './AddVendorProduct';
import VendorProductCard from './VendorProductCard';
import { useEffect, useState } from 'react';
import AppLoading from '../../utils/AppLoading';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
const PRODUCT_LIST_URL = "/vendors/{id}/products";

const VendorProductsList = () => {

    const { auth, setAuth } = useAuth();
    const [showAddModal, setShowAddModal] = useState(false);
    const location = useLocation();
    const { t } = useTranslation();
    const pInfo = t("productFormInfo")
    const vendor = location?.state?.vendor;
    // const vendorProductsUrl = PRODUCT_LIST_URL.replace("{id}", `${vendor?.vendorId??auth.vendor?.vendorId}`).concat("?roleName=VENDOR"); // old code
    const vendorProductsUrl = PRODUCT_LIST_URL.replace("{id}", `${vendor?.vendorId ?? auth.vendor?.vendor_id}`); // new code
    const sessionToken = auth.token;
    const [state, setUrl, setChangeData] = useAxiosFetchApi(null, {}, sessionToken);
    const productList = state.data?.data?.list;
    const { products, setProducts } = useProductsData();

    useEffect(() => {
        setProducts(state.data?.data?.list)
        setUrl(vendorProductsUrl)
    }, [vendorProductsUrl, state.data?.data, setProducts, setUrl])

    useEffect(() => {
        if (vendor) {
            setAuth((prev) => ({ ...prev, vendor }));
        }
    }, [vendor, setAuth]);

    function onTogglePublishing(published, productId) {
        const otherProducts = productList.filter(prod => prod.productId !== productId);
        const selectedProduct = productList.find(prod => prod.productId === productId);
        setChangeData({ list: [...otherProducts, { ...selectedProduct, published: published }] })
    }
    return (
        <>
            <div className="flex justify-between mb-10">
                <h2>{pInfo.products}</h2>
                <button className="bg-secondary-color text-white"
                    onClick={() => setShowAddModal(true)}
                >{pInfo.addProductTitle}</button>
            </div>
            <div className='grid md:grid-cols-2 lg:grid-cols-3 grid-cols-1 gap-8'>
                {state.isLoading ? <div className="w-full h-[70vh] flex justify-center items-center">
                    <AppLoading />
                </div>
                    : !products
                        ? <div className='flex justify-center items-center h-[70vh] capitalize w-full'>{state.data?.message ?? state.error?.message}</div>
                        : products
                            .sort((a, b) => {
                                if (a.name < b.name) return -1;
                                if (a.name > b.name) return 1;
                                return 0
                            }).map((product) => {
                                return <VendorProductCard key={product.productId}
                                    product={product}
                                    onTogglePublishing={onTogglePublishing} />
                            })
                }
            </div>
            <EditProductModal showModal={showAddModal} setShowModal={setShowAddModal} target="Product">
                <AddVendorProduct currentProduct={vendor} handleCloseAddModal={setShowAddModal} setProducts={setProducts} products={productList} />
            </EditProductModal>
        </>
    )
}

export default VendorProductsList